import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getFacturesByEleveId, reset } from '../factures/facture.reducer';
import { Table, Spin, Tag } from 'antd';
import { TextFormat } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { AUTHORITIES } from 'app/config/constants';
import { hasAnyAuthority } from 'app/shared/auth/private-route';

interface IPaiementsTab {
  props: RouteComponentProps<{ id: string; ecoleid: string; anneeScolaireId: string }>;
  eleveId?: string;
  isActive: boolean;
  anneeScolaireId?: string;
}

const PaiementsTab: React.FC<IPaiementsTab> = ({ eleveId, isActive, props, anneeScolaireId }) => {
  const dispatch = useAppDispatch();
  const { facturesByEleve } = useAppSelector(state => state.facture);
  const loading = useAppSelector(state => state.facture.loading);
  const isSecretaire = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SECRETAIRE]));
  const moisListe = [
    'JANVIER',
    'FEVRIER',
    'MARS',
    'AVRIL',
    'MAI',
    'JUIN',
    'JUILLET',
    'AOUT',
    'SEPTEMBRE',
    'OCTOBRE',
    'NOVEMBRE',
    'DECEMBRE',
  ];

  useEffect(() => {
    dispatch(reset());
    if (isActive) {
      const entity = {
        eleveId,
        anneeScolaireId,
      };
      dispatch(getFacturesByEleveId(entity));
    }
  }, [dispatch, eleveId, isActive]);

  const sortedFacturesData = facturesByEleve
    ?.map(f => ({
      id: f.factureId,
      key: f.numeroFacture,
      statutFacture: f.statutFacture,
      dateEmission: f.dateEmission,
      datePaiement: f.datePaiement,
      montant: `${f.montant} CFA`,
      mois: f.scolarite || '',
    }))
    .reverse()
    ?.sort((a, b) => moisListe.indexOf(a.mois.split(' ')[0]) - moisListe.indexOf(b.mois.split(' ')[0]));

  const facturesColumns = [
    {
      title: 'Factures',
      dataIndex: 'mois',
      key: 'mois',
      render: (text, record) => (
        <Link to={!isSecretaire && `/scolarite/${props.match.params.ecoleid}/${anneeScolaireId}/${record.id}/details`}>
          <strong>{text}</strong>
        </Link>
      ),
      align: 'center' as const,
    },
    {
      title: 'Date Emission',
      dataIndex: 'dateEmission',
      key: 'dateEmission',
      align: 'center' as const,
      render: date => <TextFormat type="date" value={date} format={APP_DATE_FORMAT} />,
    },
    { title: 'Montant', dataIndex: 'montant', key: 'montant', align: 'center' as const },
    {
      title: 'Date Paiement',
      dataIndex: 'datePaiement',
      key: 'datePaiement',
      align: 'center' as const,
      render: date => date && <TextFormat type="date" value={date} format={APP_DATE_FORMAT} />,
    },
    {
      title: 'Statut',
      dataIndex: 'statutFacture',
      key: 'statutFacture',
      align: 'center' as const,
      render(statut) {
        switch (statut) {
          case 'EN_ATTENTE':
            return <Tag color="red">En attente</Tag>;
          case 'EMISE':
            return <Tag color="blue">Envoyée</Tag>;
          case 'PAYEE':
            return <Tag color="green">Payée</Tag>;
          case 'CREE':
            return <Tag color="#999">Crée</Tag>;
          default:
            return <Tag color="#999">{statut}</Tag>;
        }
      },
    },
  ];

  return (
    <>
      {/* <h5 style={{ textAlign: 'center' as const }}>Historique Paiements Scolarite</h5> */}
      <Spin spinning={loading} tip="Chargement...">
        {sortedFacturesData?.length > 0 ? (
          <Table columns={facturesColumns} dataSource={sortedFacturesData} bordered pagination={false} />
        ) : (
          <div style={{ textAlign: 'center' as const, padding: '20px' }}>Aucun historique de paiement trouvé</div>
        )}
      </Spin>
    </>
  );
};

export default PaiementsTab;
